import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SvgIcon } from "@mui/material";
import { ReactComponent as HomeIcon } from "../../../img/svg/home-retos.svg";
import { ReactComponent as MedallaRetos } from "../../../img/svg/medalla-retos.svg";
import { ReactComponent as QuetzalesIcon } from "../../../img/svg/quetzales-retos.svg";
import {
  NavigationContainer,
  NavigationItemsContainer,
  NavigationIconButton,
  ActiveIndicator,
} from "./styled";

export default function NavigationBar() {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentMonth = () => {
    const currentDate = new Date();
    return currentDate.getMonth() + 1;
  };

  const handleNavigation = (path) => {
    if (path === "/prizes") {
      const currentMonth = getCurrentMonth();
      navigate(`${path}/${currentMonth}`);
    } else {
      navigate(path);
    }
  };

  const isActive = (path) => {
    if (path === "/") {
      return (
        location.pathname === "/" ||
        location.pathname.startsWith("/recompensas/")
      );
    }
    if (path === "/prizes") {
      return (
        location.pathname === "/prizes" ||
        location.pathname.startsWith("/prizes/")
      );
    }
    return location.pathname === path;
  };

  const getIconColor = (path) => {
    return isActive(path) ? "#003865" : "#00C1D4";
  };

  const navigationItems = [
    {
      path: "/",
      label: "Home",
      icon: HomeIcon,
      id: "Btn-home-retos",
    },
    {
      path: "/prizes",
      label: "Prizes",
      icon: MedallaRetos,
      id: "Btn-premio-retos",
    },
    {
      path: "/tester",
      label: "Tester",
      icon: QuetzalesIcon,
      id: "Btn-testfinanciero-retos",
    },
  ];

  return (
    <NavigationContainer>
      <NavigationItemsContainer>
        {navigationItems.map((item, index) => (
          <NavigationIconButton
            key={index}
            id={item.id}
            onClick={() => handleNavigation(item.path)}
            isActive={isActive(item.path)}
          >
            <SvgIcon
              component={item.icon}
              inheritViewBox
              sx={{
                fontSize: "2rem",
                color: getIconColor(item.path),
                fill: getIconColor(item.path),
                "& path": {
                  fill: getIconColor(item.path),
                },
                "& svg": {
                  fill: getIconColor(item.path),
                },
                marginBottom: isActive(item.path) ? "2px" : 0,
              }}
            />
            {isActive(item.path) && <ActiveIndicator />}
          </NavigationIconButton>
        ))}
      </NavigationItemsContainer>
    </NavigationContainer>
  );
}
